module.exports = window["MaterialUI"].Card;